export default class User {
  constructor () {
    this.id = ''
    this.fname = ''
    this.lname = ''
    this.email = ''
    this.su = false
    this.active = false
  }
}
